export default "__VITE_ASSET__D2wNtDZ8__"